export const ASSETS_CATEGORY_LOADING = 'ASSETS_CATEGORY_LOADING';
export const ASSETS_CATEGORY_ERROR = 'ASSETS_CATEGORY_ERROR';
export const ASSETS_CATEGORY_SUCCESS = 'ASSETS_CATEGORY_SUCCESS';
